import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import historyReducer from './historyReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const appReducer = combineReducers({
  customization: customizationReducer,
  history: historyReducer
});

const reducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default reducer;
